<template>
  <div
    class="bg-cool-gray-50 py-4 px-4 overflow-hidden sm:px-6 lg:px-8 lg:py-12"
  >
  
    <div v-if="modal" class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog"
      aria-modal="true">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
 
        <div @click="modal=false" class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true">
        </div>

       
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

     
        <div
          class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6">
          <div>
            <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
              <!-- Heroicon name: outline/check -->
              <svg class="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            
            </div>
            <div class="mt-3 text-center sm:mt-5">
              <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                عفواً
              </h3>
              <div class="mt-2">
                <p class="text-base text-gray-500">
                  {{ message }}
                </p>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-6">
            <a @click="modal=false"
              class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm">
              العودة
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="relative max-w-xl mx-auto">
      <div class="mb-4">
        <img
          class="
            object-cover object-center
            rounded
            justify-center
            mx-auto
            w-32
            mb-4
          "
          alt="hero"
          src=".././assets/logo.png"
        />

        <!-- <img  src="../../logo.png" class="w-64  m-auto"  /> -->
        <div class="text-center items-center">
          <!-- <img  src="../../logo.png" class="w-64  m-auto"  /> -->
          <h2
            class="
              text-2xl
              tracking-tight
              leading-10
              font-bold
              text-teal-600
              sm:text-2xl sm:leading-none
              md:text-2xl
            "
          >
            <br class="xl:hidden" />
            <span class="text-2xl">مـنصة صـحتنا الـرقمية </span>
          </h2>
          <p class="text-lg max-w-md mx-auto text-gray-500">
            تسجيل مرضى الأورام و ذوي الامراض المزمنة
          </p>
        </div>
      </div>

 

          <div class="mt-8 sm:mx-auto sm:w-full " v-if="step == 1">
              <div class="bg-white py-8 mb-8 px-4 shadow sm:rounded-lg sm:px-10">
                <form   class="space-y-6">
                  <div>
                    <label for="email" class="block text-sm font-medium text-gray-700">
                      رقم الوطني
                    </label>
                    <div class="mt-1">
                      <input v-model="login_nid" required id="nid" name="nid" type="number" autocomplete="number"
                        class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-center">
                    </div>
                  </div>

                  <div>
                    <label for="password" class="block text-sm font-medium text-gray-700">
                      رقم الهاتف
                    </label>
                    <div class="mt-1">
                      <input v-model="login_phone" name="nid" type="number" autocomplete="number" required
                        class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-center">
                    </div>
                  </div>
                  <div>
                    <a @click="login"
                      class="w-full flex justify-center py-2 mb-3 px-4 border border-transparent rounded-md shadow-sm text-base font-bold text-white bg-teal-500 hover:bg-blue-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                      تسجيل 
                    </a>
                  </div>
                </form>


              </div>
            </div>
            
    <div class="relative" v-else-if="step == 2">
     <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
              <div class="bg-white py-8 mb-8 px-4 shadow sm:rounded-lg sm:px-10">
                <form  class="space-y-6">


                  <div>
                    <label for="password" class="block text-sm font-medium text-gray-700">
                      رقم التحقق
                    </label>
                    <div class="mt-1">
                      <input v-model="login_otp" name="nid" type="number" autocomplete="number" required
                        class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-center">
                    </div>
                  </div>



                  <div>
                    <a @click="step = 3"
                      class="w-full flex justify-center py-2 mb-3 px-4 border border-transparent rounded-md shadow-sm text-lg font-bold text-white bg-teal-500 hover:bg-teal-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                      تأكيد
                    </a>
                  </div>
                </form>


              </div>
            </div>
    </div>
      <div class="overflow-hidden rounded-lg bg-white shadow mt-12" v-if="step == 3">
        <div class="px-4 py-5 sm:p-6">
          <ValidationObserver
            v-slot="{ handleSubmit, errors, invalid, failed }"
            v-if="!success"
          >
            <form
              @submit.prevent="handleSubmit(send)"
              class="
                grid grid-cols-1
                row-gap-6
                sm:grid-cols-4 sm:col-gap-8
                text-right
              "
            >
              <div class="sm:col-span-4 mb-2">
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                  البيانات الشخصية
                </h3>
                <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-400">
                  لتأكيد الهوية و المصادقة على البيانات
                </p>
              </div>

              <div class="sm:col-span-4">
                <label
                  for="first_name"
                  class="block text-lg font-bold leading-5 text-gray-900"
                  >الاسم الرباعي</label
                >
                <ValidationProvider
                  name="firstName"
                  rules="required|max:20|regex:^[\u0621-\u064A ]+$"
                  v-slot="v"
                >
                  <div class="mt-2 relative rounded-md shadow-sm">
                    <input
                      v-model="current_user.name"
                      class="
                        form-input
                        py-3
                        px-4
                        block
                        w-full
                        transition
                        ease-in-out
                        duration-150
                        text-center
                        bg-gray-100
                      "
                      disabled
                      :class="{ ' border border-red-500': v.errors[0] }"
                    />
                  </div>
                  <p
                    class="
                      text-red-500
                      systemfont
                      font-bold
                      text-base
                      mt-2
                      border-none
                    "
                  >
                    {{ v.errors[0] }}
                  </p>
                </ValidationProvider>
              </div>

              <div class="sm:col-span-4">
                <label
                  for="nid"
                  class="block text-lg font-bold leading-5 text-gray-900"
                  >الرقم الوطني</label
                >

                <ValidationProvider
                  name="nid"
                  rules="required|digits:12|regex:^[1-2].*"
                  v-slot="v"
                >
                  <div class="mt-2 relative rounded-md shadow-sm">
                    <input
                      id="nid"
                      v-model="login_nid"
                      disabled
                      type="number"
                      class="
                        form-input
                        py-3
                        px-4
                        block
                        w-full
                        transition
                        te
                        ease-in-out
                        duration-150
                        text-center           bg-gray-100
                      "
                      :class="{ ' border border-red-500': v.errors[0] }"
                    />
                  </div>
                  <p
                    class="
                      text-red-500
                      systemfont
                      font-bold
                      text-base
                      mt-2
                      border-none
                    "
                    v-html="v.errors[0]"
                  ></p>
                </ValidationProvider>
              </div>
              <div class="sm:col-span-4">
                <label
                  for="familyBookid"
                  class="block text-lg font-bold leading-5 text-gray-900"
                  >تاريخ الميلاد</label
                >
                <ValidationProvider
                  name="familyBookid"
                  rules="required"
                  v-slot="v"
                >
                  <div class="mt-2 relative rounded-md shadow-sm">
                    <input
                      id="familyBookid"
                      v-model="current_user.children_number"
                      disabled
                      type="date"
                      class="
                        form-input
                        py-3
                        px-4
                        block
                        w-full
                        transition
                        te
                        ease-in-out
                        duration-150
                        text-center           bg-gray-100
                      "
                      :class="{ ' border border-red-500': v.errors[0] }"
                    />
                  </div>
                  <p
                    class="
                      text-red-500
                      systemfont
                      font-bold
                      text-base
                      mt-2
                      border-none
                    "
                    v-html="v.errors[0]"
                  ></p>
                </ValidationProvider>
              </div>

              <div class="sm:col-span-4 mb-2 pt-8 border-t-2 mt-1">
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                  بيانات التواصل
                </h3>
                <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-400">
                  لمراسلتك في حال وجود أي خطأ في البيانات التي قمت بإدخالها
                </p>
              </div>

              <div class="sm:col-span-4">
                <label
                  for="mobile1"
                  class="block text-lg font-bold leading-5 text-gray-900"
                  >رقم الهاتف</label
                >
                <ValidationProvider
                  name="mobile1"
                  rules="required|regex:^09\d{8}$"
                  v-slot="v"
                >
                  <div class="mt-2 relative rounded-md shadow-sm">
                    <input
                      v-model="login_phone"
                      type="number"
                      class="
                        form-input
                        py-3
                        px-4
                        block
                        w-full
                        transition
                        te
                        ease-in-out
                        duration-150
                        text-center
                        disabled           bg-gray-100
                      " disabled
                      :class="{ ' border border-red-500': v.errors[0] }"
                    />
                  </div>
                  <p
                    class="
                      text-red-500
                      systemfont
                      font-bold
                      text-base
                      mt-2
                      border-none
                    "
                  >
                    {{ v.errors[0] }}
                  </p>
                </ValidationProvider>
              </div>
              <div class="sm:col-span-4">
                <label
                  for="mobile2"
                  class="block text-lg font-bold leading-5 text-gray-900"
                  >رقم الهاتف الثاني</label
                >
                <ValidationProvider
                  name="mobile2"
                  rules="regex:^09\d{8}$"
                  v-slot="v"
                >
                  <div class="mt-2 relative rounded-md shadow-sm">
                    <input
                      v-model="info.mobile2"
                      type="number"
                      class="
                        form-input
                        py-3
                        px-4
                        block
                        w-full
                        transition
                        te
                        ease-in-out
                        duration-150
                        text-center
                      "
                      :class="{ ' border border-red-500': v.errors[0] }"
                    />
                  </div>
                  <p
                    class="
                      text-red-500
                      systemfont
                      font-bold
                      text-base
                      mt-2
                      border-none
                    "
                  >
                    {{ v.errors[0] }}
                  </p>
                </ValidationProvider>
              </div>

              <div class="sm:col-span-4 mb-2 pt-8 border-t-2 mt-1">
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                  بيانات الإقامة
                </h3>
                <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-400">
                  الرّجاء إدخال البيانات وفقاً للسجلات الرّسمية
                </p>
              </div>

              <!-- <div class="sm:col-span-4">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >حالة الاقامة</label
              >
              <div class="mt-2 relative rounded-md shadow-sm">
                <select
                  id="type"
                  v-model="info.citzen_type"
                  class="mt-1 form-select form-input block w-full pl-3 pr-10 py-3 px-4 text-lg leading-6 text-center border-gray-300 focus:outline-none focus:shadow-outline-primary focus:border-primary-300 sm:text-lg text-center"
                >
                  <option selected disabled>اختر</option>
                  <option value="1" class="font-bold">مقيم و مقيد</option>
                  <option value="2" class="font-bold">مقيم و غير مقيد</option>
                </select>
              </div>
            </div>

            <div class="sm:col-span-4" v-if="info.citzen_type == 2">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >نوع الاقامة</label
              >
              <div class="mt-2 relative rounded-md shadow-sm">
                <select
                  id="type"
                  v-model="info.type"
                  class="mt-1 form-select form-input block w-full pl-3 pr-10 py-3 px-4 text-lg leading-6 text-center border-gray-300 focus:outline-none focus:shadow-outline-primary focus:border-primary-300 sm:text-lg text-center"
                >
                  <option selected disabled>اختر</option>
                  <option value="" class="font-bold">دائم</option>
                  <option value="home" class="font-bold">مؤقتة</option>
                </select>
              </div>
            </div>

            <div class="sm:col-span-4" v-if="info.citzen_type == 2">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >سبب الاقامة</label
              >
              <div class="mt-2 relative rounded-md shadow-sm">
                <select
                  id="package"
                  v-model="info.reason"
                  class="mt-1 form-select form-input block w-full pl-3 pr-10 py-3 px-4 text-lg leading-6 text-center border-gray-300 focus:outline-none focus:shadow-outline-primary focus:border-primary-300 sm:text-lg"
                >
                  <option selected disabled>اختر</option>
                  <option value="1" class="font-bold">نازح</option>
                  <option value="2" class="font-bold">موظف</option>
                </select>
              </div>
            </div>

            <div class="sm:col-span-2" v-if="info.reason == 2">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >الوظيفة</label
              >
              <div class="mt-2 relative rounded-md shadow-sm">
                <input
                  id="father_name"
                  class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
                />
              </div>
            </div>

            <div class="sm:col-span-2" v-if="info.reason == 2">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >الجهة</label
              >
              <div class="mt-2 relative rounded-md shadow-sm">
                <input
                  id="father_name"
                  class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
                />
              </div>
            </div>

            <div class="sm:col-span-4" v-if="info.reason == 2">
              <label
                for="package"
                class="block text-lg font-bold leading-5 text-gray-900"
                >القطاع التابعة له جهة العمل</label
              >
              <div class="mt-2 relative rounded-md shadow-sm">
                <input
                  id="father_name"
                  class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
                />
              </div>
            </div> -->
              <div class="sm:col-span-4">
                <label
                  for="residence"
                  class="block text-lg font-bold leading-5 text-gray-900"
                  >مكان الاقامة</label
                >
                <ValidationProvider
                  name="residence"
                  rules="required"
                  v-slot="v"
                >
                  <div class="mt-2 relative rounded-md shadow-sm">
                    <select
                      id="type"
                      v-model="info.residence"
                      class="
                        mt-1
                        form-select form-input
                        block
                        w-full
                        pl-3
                        pr-10
                        py-3
                        px-4
                        text-lg
                        leading-6
                        text-center
                        border-gray-300
                        focus:outline-none
                        focus:shadow-outline-primary
                        focus:border-primary-300
                        sm:text-lg
                      "
                      :class="{ ' border border-red-500': v.errors[0] }"
                    >
                      <option selected disabled :value="null">اختر</option>
                      <option
                        v-for="city in cities"
                        :key="city.id"
                        :value="city.name"
                        class="font-bold"
                      >
                        {{ city.name }}
                      </option>
                      <option :value="'other'">اخرى</option>
                    </select>
                  </div>
                  <p
                    class="
                      text-red-500
                      systemfont
                      font-bold
                      text-base
                      mt-2
                      border-none
                    "
                  >
                    {{ v.errors[0] }}
                  </p>
                </ValidationProvider>
              </div>

              <div class="sm:col-span-4" v-if="info.residence == 'other'">
                <label
                  for="otherresidence"
                  class="block text-lg font-bold leading-5 text-gray-900"
                >
                  اكتب مكان الاقامة</label
                >
                <ValidationProvider
                  name="otherresidence"
                  rules="required|max:20|regex:^[\u0621-\u064A ]+$"
                  v-slot="v"
                >
                  <div class="mt-2 relative rounded-md shadow-sm">
                    <input
                      v-model="info.otherresidence"
                      class="
                        form-input
                        py-3
                        px-4
                        block
                        w-full
                        transition
                        ease-in-out
                        duration-150
                      "
                      :class="{ ' border border-red-500': v.errors[0] }"
                    />
                  </div>
                  <p
                    class="
                      text-red-500
                      systemfont
                      font-bold
                      text-base
                      mt-2
                      border-none
                    "
                  >
                    {{ v.errors[0] }}
                  </p>
                </ValidationProvider>
              </div>

              <div class="sm:col-span-4 pt-8 border-t-2 mt-1 mb-2">
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                  البيانات الأمراض المزمنة
                </h3>
                <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-400">
                  الرّجاء إدخال بيانات المرضية
                </p>
              </div>

              <div class="sm:col-span-4">
                <!--
  This example requires Tailwind CSS v2.0+ 
  
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
-->
                <fieldset>
                  <div class="  space-y-5 mb-10">
                    <div
                      class="
                        cursor-pointer
                        rounded-lg
                        border
                        bg-white
                        p-6
                        shadow-sm
                        focus:outline-none
                      "
                      @click="d1 = !d1"
                      :class="{ 'border-teal-500 ring-3 ring-teal-500': d1 }"
                    >
                      <div class="relative flex items-start py-4">
                        <div class="min-w-0 flex-1 text-xl">
                          <svg
                            v-if="checked"
                            class="flex-shrink-0 h-6 w-6 text-teal-700"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                          <label
                            for="person-1"
                            class="select-none font-bold text-gray-700"
                            :class="{
                              ' text-teal-500': d1,
                            }"
                            >السكري
                          </label>
                        </div>
                        <div class="ml-3 flex h-5 items-center">
                          <input
                          
                            name="person-1"
                            v-model="d1"
                            type="checkbox"
                            class="
                              h-4
                              w-4
                              rounded
                              border-gray-300
                              text-teal-600
                              focus:ring-teal-500
                              checked:bg-teal-500
                            "
                          />
                        </div>
                      </div>

                      <!-- This example requires Tailwind CSS v2.0+ -->
                      <div v-on:click.stop>
                        <fieldset class="my-5" v-if="d1">
                          <div class="grid grid-cols-2 gap-3 sm:grid-cols-2">
                            <Doption name="حقن الأنسولين " v-on:click.stop />
                            <Doption name="أقراص" v-on:click.stop />
                          </div>
                        </fieldset>
                      </div>
                    </div>

                    <div
                      class="
                        cursor-pointer
                        rounded-lg
                        border
                        bg-white
                        p-6
                        shadow-sm
                        focus:outline-none
                      "
                      @click="d2 = !d2"
                      :class="{ 'border-teal-500 ring-3 ring-teal-500': d2 }"
                    >
                      <div class="relative flex items-start py-4">
                        <div class="min-w-0 flex-1 text-xl">
                          <label
                            for="person-1"
                            class="select-none font-bold text-gray-700"
                            :class="{
                              ' text-teal-500': d2,
                            }"
                            >الضغط
                          </label>
                        </div>
                        <div class="ml-3 flex h-5 items-center">
                          <input
                          
                            name="person-1"
                            v-model="d2"
                            type="checkbox"
                            class="
                              h-4
                              w-4
                              rounded
                              border-gray-300
                              text-teal-600
                              focus:ring-teal-500
                              checked:bg-teal-500
                            "
                          />
                        </div>
                      </div>

                      <!-- This example requires Tailwind CSS v2.0+ -->
                    </div>

                                        <div
                      class="
                        cursor-pointer
                        rounded-lg
                        border
                        bg-white
                        p-6
                        shadow-sm
                        focus:outline-none
                      "
                      @click="d3 = !d3"
                      :class="{ 'border-teal-500 ring-3 ring-teal-500': d3 }"
                    >
                      <div class="relative flex items-start py-4">
                        <div class="min-w-0 flex-1 text-xl">
                          <svg
                            v-if="checked"
                            class="flex-shrink-0 h-6 w-6 text-teal-700"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                          <label
                            for="person-1"
                            class="select-none font-bold text-gray-700"
                            :class="{
                              ' text-teal-500': d3,
                            }"
                            >أمراض القلب 
                          </label>
                        </div>
                        <div class="ml-3 flex h-5 items-center">
                          <input
                          
                            name="person-1"
                            v-model="d3"
                            type="checkbox"
                            class="
                              h-4
                              w-4
                              rounded
                              border-gray-300
                              text-teal-600
                              focus:ring-teal-500
                              checked:bg-teal-500
                            "
                          />
                        </div>
                      </div>

                      <!-- This example requires Tailwind CSS v2.0+ -->
                      <div v-on:click.stop>
                        <fieldset class="my-5" v-if="d3">
                          <div class="grid grid-cols-2 gap-3 sm:grid-cols-2">
                            <Doption name="أمراض شرايين القلب " v-on:click.stop />
                            <Doption name="مشاكل في عضلة القلب " v-on:click.stop />
                            <Doption name="مشاكل في الصمامات " v-on:click.stop />
                            <Doption name="أخرى " v-on:click.stop />
                          </div>
                        </fieldset>
                      </div>
                    </div>

                                <div
                      class="
                        cursor-pointer
                        rounded-lg
                        border
                        bg-white
                        p-6
                        shadow-sm
                        focus:outline-none
                      "
                      @click="d4 = !d4"
                      :class="{ 'border-teal-500 ring-3 ring-teal-500': d4 }"
                    >
                      <div class="relative flex items-start py-4">
                        <div class="min-w-0 flex-1 text-xl">
                          <svg
                            v-if="checked"
                            class="flex-shrink-0 h-6 w-6 text-teal-700"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                          <label
                            for="person-1"
                            class="select-none font-bold text-gray-700"
                            :class="{
                              ' text-teal-500': d4,
                            }"
                            >أمراض الجهاز التنفسي 
                          </label>
                        </div>
                        <div class="ml-3 flex h-5 items-center">
                          <input
                          
                            name="person-1"
                            v-model="d4"
                            type="checkbox"
                            class="
                              h-4
                              w-4
                              rounded
                              border-gray-300
                              text-teal-600
                              focus:ring-teal-500
                              checked:bg-teal-500
                            "
                          />
                        </div>
                      </div>

                      <!-- This example requires Tailwind CSS v2.0+ -->
                      <div v-on:click.stop>
                        <fieldset class="my-5" v-if="d4">
                          <div class="grid grid-cols-2 gap-3 sm:grid-cols-2">
                            <Doption name="الربو تضيق في الشعب الهوائية  " v-on:click.stop />
                            <Doption name="التليف الرئوي  " v-on:click.stop />
                            <Doption name="الدرن الرئوي  " v-on:click.stop />
                            <Doption name="أخرى  " v-on:click.stop />
                          </div>
                        </fieldset>
                      </div>
                    </div>

                                <div
                      class="
                        cursor-pointer
                        rounded-lg
                        border
                        bg-white
                        p-6
                        shadow-sm
                        focus:outline-none
                      "
                      @click="d5 = !d5"
                      :class="{ 'border-teal-500 ring-3 ring-teal-500': d5 }"
                    >
                      <div class="relative flex items-start py-4">
                        <div class="min-w-0 flex-1 text-xl">
                          <svg
                            v-if="checked"
                            class="flex-shrink-0 h-6 w-6 text-teal-700"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                          <label
                            for="person-1"
                            class="select-none font-bold text-gray-700"
                            :class="{
                              ' text-teal-500': d5,
                            }"
                            >أمراض الكبد  
                          </label>
                        </div>
                        <div class="ml-3 flex h-5 items-center">
                          <input
                          
                            name="person-1"
                            v-model="d5"
                            type="checkbox"
                            class="
                              h-4
                              w-4
                              rounded
                              border-gray-300
                              text-teal-600
                              focus:ring-teal-500
                              checked:bg-teal-500
                            "
                          />
                        </div>
                      </div>

                      <!-- This example requires Tailwind CSS v2.0+ -->
                      <div v-on:click.stop>
                        <fieldset class="my-5" v-if="d5">
                          <div class="grid grid-cols-2 gap-3 sm:grid-cols-2">
                            <Doption name="تليف الكبد  " v-on:click.stop />
                            <Doption name="التهابات الكبد  " v-on:click.stop />
                          
                            <Doption name="أخرى " v-on:click.stop />
                          </div>
                        </fieldset>
                      </div>
                    </div>

                                <div
                      class="
                        cursor-pointer
                        rounded-lg
                        border
                        bg-white
                        p-6
                        shadow-sm
                        focus:outline-none
                      "
                      @click="d6 = !d6"
                      :class="{ 'border-teal-500 ring-3 ring-teal-500': d6 }"
                    >
                      <div class="relative flex items-start py-4">
                        <div class="min-w-0 flex-1 text-xl">
                          <svg
                            v-if="checked"
                            class="flex-shrink-0 h-6 w-6 text-teal-700"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                          <label
                            for="person-1"
                            class="select-none font-bold text-gray-700"
                            :class="{
                              ' text-teal-500': d6,
                            }"
                            >أمراض الجهاز الهضمي   
                          </label>
                        </div>
                        <div class="ml-3 flex h-5 items-center">
                          <input
                          
                            name="person-1"
                            v-model="d6"
                            type="checkbox"
                            class="
                              h-4
                              w-4
                              rounded
                              border-gray-300
                              text-teal-600
                              focus:ring-teal-500
                              checked:bg-teal-500
                            "
                          />
                        </div>
                      </div>

                      <!-- This example requires Tailwind CSS v2.0+ -->
                      <div v-on:click.stop>
                        <fieldset class="my-5" v-if="d6">
                          <div class="grid grid-cols-2 gap-3 sm:grid-cols-2">
                            <Doption name="قرحة المعدة " v-on:click.stop />
                            <Doption name="تقرحات الأمعاء " v-on:click.stop />
                            <Doption name="حساسية النعمة  " v-on:click.stop />
                            <Doption name="أخرى " v-on:click.stop />
                          </div>
                        </fieldset>
                      </div>
                    </div>

                                <div
                      class="
                        cursor-pointer
                        rounded-lg
                        border
                        bg-white
                        p-6
                        shadow-sm
                        focus:outline-none
                      "
                      @click="d7 = !d7"
                      :class="{ 'border-teal-500 ring-3 ring-teal-500': d7 }"
                    >
                      <div class="relative flex items-start py-4">
                        <div class="min-w-0 flex-1 text-xl">
                          <svg
                            v-if="checked"
                            class="flex-shrink-0 h-6 w-6 text-teal-700"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                          <label
                            for="person-1"
                            class="select-none font-bold text-gray-700"
                            :class="{
                              ' text-teal-500': d7,
                            }"
                            >أمراض الكلى    
                          </label>
                        </div>
                        <div class="ml-3 flex h-5 items-center">
                          <input
                          
                            name="person-1"
                            v-model="d7"
                            type="checkbox"
                            class="
                              h-4
                              w-4
                              rounded
                              border-gray-300
                              text-teal-600
                              focus:ring-teal-500
                              checked:bg-teal-500
                            "
                          />
                        </div>
                      </div>

                      <!-- This example requires Tailwind CSS v2.0+ -->
                      <div v-on:click.stop>
                        <fieldset class="my-5" v-if="d7">
                          <div class="grid grid-cols-2 gap-3 sm:grid-cols-2">
                            <Doption name="قصور في وظائف الكلى " v-on:click.stop />
                            <Doption name="فشل كلوى " v-on:click.stop />
 
                            <Doption name="أخرى " v-on:click.stop />
                          </div>
                        </fieldset>
                      </div>
                    </div>
                                <div
                      class="
                        cursor-pointer
                        rounded-lg
                        border
                        bg-white
                        p-6
                        shadow-sm
                        focus:outline-none
                      "
                      @click="d8 = !d8"
                      :class="{ 'border-teal-500 ring-3 ring-teal-500': d8 }"
                    >
                      <div class="relative flex items-start py-4">
                        <div class="min-w-0 flex-1 text-xl">
                          <svg
                            v-if="checked"
                            class="flex-shrink-0 h-6 w-6 text-teal-700"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                          <label
                            for="person-1"
                            class="select-none font-bold text-gray-700"
                            :class="{
                              ' text-teal-500': d8,
                            }"
                            >  أمراض العصبية 
                          </label>
                        </div>
                        <div class="ml-3 flex h-5 items-center">
                          <input
                          
                            name="person-1"
                            v-model="d8"
                            type="checkbox"
                            class="
                              h-4
                              w-4
                              rounded
                              border-gray-300
                              text-teal-600
                              focus:ring-teal-500
                              checked:bg-teal-500
                            "
                          />
                        </div>
                      </div>

                      <!-- This example requires Tailwind CSS v2.0+ -->
                      <div v-on:click.stop>
                        <fieldset class="my-5" v-if="d8">
                          <div class="grid grid-cols-2 gap-3 sm:grid-cols-2">
                            <Doption name=" التشنجات (الصرع) " v-on:click.stop />
                            <Doption name="  التصلب اللويحي  " v-on:click.stop />
 
                            <Doption name=" التهابات الاعصاب الطرفية  " v-on:click.stop />
                            <Doption name="  اخري  " v-on:click.stop />
                          </div>
                        </fieldset>
                      </div>
                    </div>
                                <div
                      class="
                        cursor-pointer
                        rounded-lg
                        border
                        bg-white
                        p-6
                        shadow-sm
                        focus:outline-none
                      "
                      @click="d9 = !d9"
                      :class="{ 'border-teal-500 ring-3 ring-teal-500': d9 }"
                    >
                      <div class="relative flex items-start py-4">
                        <div class="min-w-0 flex-1 text-xl">
                          <svg
                            v-if="checked"
                            class="flex-shrink-0 h-6 w-6 text-teal-700"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                          <label
                            for="person-1"
                            class="select-none font-bold text-gray-700"
                            :class="{
                              ' text-teal-500': d9,
                            }"
                            >  أمراض الرثوية 
                          </label>
                        </div>
                        <div class="ml-3 flex h-5 items-center">
                          <input
                          
                            name="person-1"
                            v-model="d9"
                            type="checkbox"
                            class="
                              h-4
                              w-4
                              rounded
                              border-gray-300
                              text-teal-600
                              focus:ring-teal-500
                              checked:bg-teal-500
                            "
                          />
                        </div>
                      </div>

                      <!-- This example requires Tailwind CSS v2.0+ -->
                      <div v-on:click.stop>
                        <fieldset class="my-5" v-if="d9">
                          <div class="grid grid-cols-2 gap-3 sm:grid-cols-2">
                            <Doption name=" الذئبة الحمراء  " v-on:click.stop />
                            <Doption name="  الروماتيزم   " v-on:click.stop />
 
                        
                            <Doption name="  اخري  " v-on:click.stop />
                          </div>
                        </fieldset>
                      </div>
                    </div>

                                <div
                      class="
                        cursor-pointer
                        rounded-lg
                        border
                        bg-white
                        p-6
                        shadow-sm
                        focus:outline-none
                      "
                      @click="dc = !dc"
                      :class="{ 'border-teal-500 ring-3 ring-teal-500': dc }"
                    >
                      <div class="relative flex items-start py-4">
                        <div class="min-w-0 flex-1 text-xl">
                          <svg
                            v-if="checked"
                            class="flex-shrink-0 h-6 w-6 text-teal-700"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                          <label
                            for="person-1"
                            class="select-none font-bold text-gray-700"
                            :class="{
                              ' text-teal-500': dc,
                            }"
                            > الاورام
                          </label>
                        </div>
                        <div class="ml-3 flex h-5 items-center">
                          <input
                          
                            name="person-1"
                            v-model="dc"
                            type="checkbox"
                            class="
                              h-4
                              w-4
                              rounded
                              border-gray-300
                              text-teal-600
                              focus:ring-teal-500
                              checked:bg-teal-500
                            "
                          />
                        </div>
                      </div>

                      <!-- This example requires Tailwind CSS v2.0+ -->
                      <div v-on:click.stop>
                        <fieldset class="my-5" v-if="dc">
                          <div class="grid grid-cols-2 gap-3 sm:grid-cols-2">
                            <Doption name=" الثدي   " v-on:click.stop />
                            <Doption name=" القولون    " v-on:click.stop />
                            <Doption name=" الرئة     " v-on:click.stop />
                            <Doption name=" الكبد    " v-on:click.stop />
                            <Doption name=" العظام    " v-on:click.stop />
                            <Doption name=" بروستات     " v-on:click.stop />
         
                          </div>
                        </fieldset>
                      </div>
                    </div>

                                        <div
                      class="
                        cursor-pointer
                        rounded-lg
                        border
                        bg-white
                        p-6
                        shadow-sm
                        focus:outline-none
                      "
                      @click="d2 = !d2"
                      :class="{ 'border-teal-500 ring-3 ring-teal-500': d2 }"
                    >
                      <div class="relative flex items-start py-4">
                        <div class="min-w-0 flex-1 text-xl">
                          <label
                            for="person-1"
                            class="select-none font-bold text-gray-700"
                            :class="{
                              ' text-teal-500': d2,
                            }"
                            >ضمور العضلات 
                          </label>
                        </div>
                        <div class="ml-3 flex h-5 items-center">
                          <input
                          
                            name="person-1"
                            v-model="d2"
                            type="checkbox"
                            class="
                              h-4
                              w-4
                              rounded
                              border-gray-300
                              text-teal-600
                              focus:ring-teal-500
                              checked:bg-teal-500
                            "
                          />
                        </div>
                      </div>

                      <!-- This example requires Tailwind CSS v2.0+ -->
                    </div>
                  </div>
                </fieldset>
              </div>

              <!--
  Tailwind UI components require Tailwind CSS v1.8 and the @tailwindcss/ui plugin.
  Read the documentation to get started: https://tailwindui.com/documentation
-->

              <div
                class="sm:col-span-4 mt-2"
                v-if="(invalid && failed) || servererrors != null"
              >
                <div class="rounded-md bg-red-50 p-6">
                  <div class="flex">
                    <div class="flex-shrink-0">
                      <!-- Heroicon name: x-circle -->
                      <svg
                        class="h-5 w-5 text-red-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                    <div class="mr-3">
                      <h3 class="text-base leading-5 font-medium text-red-500">
                        هناك أخطاء في إدخالك للحقول يجب معالجتها قبل الاستمرار
                      </h3>
                      <div
                        class="mt-2 text-base leading-5 text-red-700"
                        v-if="servererrors != null"
                      >
                        <ul class="list-disc pr-5">
                          <li class="mt-1">
                            {{ servererrors }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="sm:col-span-4 mt-1">
                <span class="w-full inline-flex rounded-md shadow-sm">
                  <button
                    type="submit"
                    class="
                      w-full
                      inline-flex
                      items-center
                      justify-center
                      px-6
                      py-4
                      border border-transparent
                      text-lg
                      leading-6
                      font-bold
                      rounded-md
                      text-white
                      bg-primary-500
                      hover:bg-primary-500
                      font
                      focus:outline-none
                      focus:border-primary-700
                      focus:shadow-outline-primary
                      active:bg-primary-700
                      transition
                      ease-in-out
                      duration-150
                    "
                  >
                    <svg
                      v-if="loading"
                      class="animate-spin -mr-1 ml-3 h-5 w-5 text-yellow-100"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        class="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        stroke-width="4"
                      ></circle>
                      <path
                        class="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>

                    تسجيل
                  </button>
                </span>
              </div>
            </form>
          </ValidationObserver>
          <div
            class="
              block
              align-bottom
              bg-white
              rounded-lg
              px-4
              pt-5
              pb-4
              text-left
              overflow-hidden
              shadow-xl
              transform
              transition-all
              mb-12
            "
            role="dialog"
            v-else
          >
            <div>
              <div
                class="
                  mx-auto
                  flex
                  items-center
                  justify-center
                  h-16
                  w-16
                  rounded-full
                  bg-yellow-100
                "
              >
                <!-- Heroicon name: check -->
                <svg
                  class="h-10 w-10 text-yellow-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
              <div class="mt-4 text-center sm:mt-5">
                <h3 class="text-lg font-bold leading-10 text-gray-900">
                  تم تسجيل بياناتك بنجاح
                </h3>
                <div class="mt-2">
                  <p class="text-lg font-medium leading-7 text-gray-500">
                    سيتم اخطارك برسالة نصية فى حال وجود خطأ بهذه البيانات
                  </p>
                </div>
              </div>
            </div>
            <div class="mt-5 sm:mt-6">
              <span class="flex w-full rounded-md shadow-sm">
                <router-link
                  to="/"
                  class="
                    inline-flex
                    justify-center
                    w-full
                    rounded-md
                    border border-transparent
                    px-4
                    py-4
                    bg-primary-500
                    text-base
                    leading-6
                    font-medium
                    text-white
                    shadow-sm
                    hover:bg-primary-400
                    focus:outline-none
                    focus:border-primary-700
                    focus:shadow-outline-primary
                    transition
                    ease-in-out
                    duration-150
                    sm:text-sm sm:leading-5
                  "
                >
                  عودة للرئيسية
                </router-link>
              </span>
            </div>
          </div>
        </div>
      </div>
      
      <div class="pt-8 border-t-2 border-gray-300 mt-10"></div>

      
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Doption from "../components/Doption.vue";

export default {
  components: {
    Doption,
  },
  data() {
    return {
      login_nid:null,
      login_phone:null,
      success: false,
      loading: false,
      step: 1,
      selectedmunicipality: null,
      servererrors: null,
      d1: false,
      d2: false,
      d3: false,
      d4: false,
      d5: false,
      d6: false,
      d7: false,
      d8: false,
      d9: false,
      dc: false,
      d11: false,
      login_otp:null,
      info: {},
      cities: [
        {
          id: 1,
          name: "البردي",
        },
        {
          id: 2,
          name: "الجغبوب",
        },
        {
          id: 3,
          name: "بئر الاشهب",
        },
        {
          id: 4,
          name: "كمبوت",
        },
        {
          id: 5,
          name: "طبرق ",
        },
        {
          id: 6,
          name: "امساعد",
        },
        {
          id: 7,
          name: "ظهر الخوير",
        },
        {
          id: 8,
          name: "عين مارة",
        },
        {
          id: 9,
          name: "البيضاء",
        },
        {
          id: 10,
          name: "الغجب",
        },
        {
          id: 11,
          name: "الأبرق",
        },
        {
          id: 12,
          name: "الفائدية",
        },
        {
          id: 13,
          name: "كرسة ",
        },
        {
          id: 14,
          name: "لملودة",
        },
        {
          id: 15,
          name: "مسة",
        },
        {
          id: 16,
          name: "قندولة",
        },
        {
          id: 17,
          name: "قرنادة",
        },
        {
          id: 18,
          name: "شحات",
        },
        {
          id: 19,
          name: "سلنطة",
        },
        {
          id: 20,
          name: "سوسة",
        },
        {
          id: 21,
          name: "زاوية بشارة",
        },
        {
          id: 22,
          name: "الفياصلة",
        },
        {
          id: 23,
          name: "الجوش الصغير",
        },
        {
          id: 24,
          name: "اللمامش",
        },
        {
          id: 25,
          name: "القنافد",
        },
        {
          id: 26,
          name: "القطع",
        },
        {
          id: 27,
          name: "القواسم",
        },
        {
          id: 28,
          name: "العرقوب",
        },
        {
          id: 29,
          name: "العوينية",
        },
        {
          id: 30,
          name: "الشويرف",
        },
        {
          id: 31,
          name: "طبقة",
        },
        {
          id: 32,
          name: "اولاد بدر",
        },
        {
          id: 33,
          name: "اولاد خليفة",
        },
        {
          id: 34,
          name: "اولاد عيسا",
        },
        {
          id: 35,
          name: "اولاد جابر",
        },
        {
          id: 36,
          name: "اولاد مسعود",
        },
        {
          id: 37,
          name: "الزنتان",
        },
        {
          id: 38,
          name: "بدر ليبيا",
        },
        {
          id: 39,
          name: "بئر الغنم",
        },
        {
          id: 40,
          name: "بو غيلان",
        },
        {
          id: 41,
          name: "أبو زيان ",
        },
        {
          id: 42,
          name: "غريان",
        },
        {
          id: 43,
          name: "جادو",
        },
        {
          id: 44,
          name: "مزدة",
        },
        {
          id: 45,
          name: "نسمة",
        },
        {
          id: 46,
          name: "القرية الغربية",
        },
        {
          id: 47,
          name: "القرية الشرقية",
        },
        {
          id: 48,
          name: "تموري",
        },
        {
          id: 49,
          name: "تردية",
        },
        {
          id: 50,
          name: "يفرن",
        },
        {
          id: 51,
          name: "الشقيقة",
        },
        {
          id: 52,
          name: "الناصرية",
        },
        {
          id: 53,
          name: "السواني",
        },
        {
          id: 54,
          name: "الطويبية",
        },
        {
          id: 55,
          name: "الزهراء",
        },
        {
          id: 56,
          name: "الماية",
        },
        {
          id: 57,
          name: "صياد",
        },
        {
          id: 58,
          name: "هون",
        },
        {
          id: 59,
          name: "سوكنة",
        },
        {
          id: 60,
          name: "ودان",
        },
        {
          id: 61,
          name: "زلة",
        },
        {
          id: 62,
          name: "الهواري",
        },
        {
          id: 63,
          name: "الجوف",
        },
        {
          id: 64,
          name: "حارة عفون",
        },
        {
          id: 65,
          name: "توبات",
        },
        {
          id: 66,
          name: "الأبيار ",
        },
        {
          id: 67,
          name: "المرج",
        },
        {
          id: 68,
          name: "برسيس",
        },
        {
          id: 69,
          name: "بطة",
        },
        {
          id: 70,
          name: "بو مريم",
        },
        {
          id: 71,
          name: "دريانة",
        },
        {
          id: 72,
          name: "جردس العبيد",
        },
        {
          id: 73,
          name: "سيدي خليفة",
        },
        {
          id: 74,
          name: "تاكنس",
        },
        {
          id: 75,
          name: "طلميثة",
        },
        {
          id: 76,
          name: "توكرة",
        },
        {
          id: 77,
          name: "العزيزية",
        },
        {
          id: 78,
          name: "اسبيعة",
        },
        {
          id: 79,
          name: "الخمس",
        },
        {
          id: 80,
          name: "الجمعة",
        },
        {
          id: 81,
          name: "القليل",
        },
        {
          id: 82,
          name: "القرابولي",
        },
        {
          id: 83,
          name: "اولاد نما",
        },
        {
          id: 84,
          name: "بني ليث",
        },
        {
          id: 85,
          name: "قصربن غشير",
        },
        {
          id: 86,
          name: "ترهونة",
        },
        {
          id: 87,
          name: "اجدابيا",
        },
        {
          id: 88,
          name: "الشوشنة",
        },
        {
          id: 89,
          name: "اوجلة",
        },
        {
          id: 90,
          name: "الزويتينة",
        },
        {
          id: 91,
          name: "جالو",
        },
        {
          id: 92,
          name: "اجخره",
        },
        {
          id: 93,
          name: "مرادة",
        },
        {
          id: 94,
          name: "مرسى البريقة",
        },
        {
          id: 95,
          name: "مسليوة",
        },
        {
          id: 96,
          name: "أبو كماش",
        },
        {
          id: 97,
          name: "العسة",
        },
        {
          id: 98,
          name: "الجميل",
        },
        {
          id: 99,
          name: "راس اجدير",
        },
        {
          id: 100,
          name: "سيدي بو زينة",
        },
        {
          id: 101,
          name: "زلطن",
        },
        {
          id: 102,
          name: "زوارة",
        },
        {
          id: 103,
          name: "الحرثة",
        },
        {
          id: 104,
          name: "الحرشة",
        },
        {
          id: 105,
          name: "الزاوية",
        },
        {
          id: 106,
          name: "صبراتة",
        },
        {
          id: 107,
          name: "صرمان",
        },
        {
          id: 108,
          name: "العجيلات",
        },
        {
          id: 109,
          name: "النواقية",
        },
        {
          id: 110,
          name: "بنغازي",
        },
        {
          id: 111,
          name: "جردينا",
        },
        {
          id: 112,
          name: "قمينس",
        },
        {
          id: 113,
          name: "سلوق",
        },
        {
          id: 114,
          name: "التميمي",
        },
        {
          id: 115,
          name: "درنة",
        },
        {
          id: 116,
          name: "مرتوبة",
        },
        {
          id: 117,
          name: "البركت",
        },
        {
          id: 118,
          name: "غات",
        },
        {
          id: 119,
          name: "البكي",
        },
        {
          id: 120,
          name: "القطرون",
        },
        {
          id: 121,
          name: "غدوة",
        },
        {
          id: 122,
          name: "مرزق",
        },
        {
          id: 123,
          name: "ترغن",
        },
        {
          id: 124,
          name: "تمسه",
        },
        {
          id: 125,
          name: "ام الارانب",
        },
        {
          id: 126,
          name: "زويلة",
        },
        {
          id: 127,
          name: "جيزاو",
        },
        {
          id: 128,
          name: "المحجوب",
        },
        {
          id: 129,
          name: "القرير",
        },
        {
          id: 130,
          name: "اولاد تليس",
        },
        {
          id: 131,
          name: "بني وليد",
        },
        {
          id: 132,
          name: "مصراتة",
        },
        {
          id: 133,
          name: "العطيات",
        },
        {
          id: 134,
          name: "قصر احمد",
        },
        {
          id: 135,
          name: "الغزايا",
        },
        {
          id: 136,
          name: "الحوامد",
        },
        {
          id: 137,
          name: "المجابرة",
        },
        {
          id: 138,
          name: "درج",
        },
        {
          id: 139,
          name: "غدامس",
        },
        {
          id: 140,
          name: "نالوت",
        },
        {
          id: 141,
          name: "سيناون",
        },
        {
          id: 142,
          name: "تكويت",
        },
        {
          id: 143,
          name: "طمزين",
        },
        {
          id: 144,
          name: "تندميرة",
        },
        {
          id: 145,
          name: "تيغيت",
        },
        {
          id: 146,
          name: "تيجي",
        },
        {
          id: 147,
          name: "وزن",
        },
        {
          id: 148,
          name: "سبها",
        },
        {
          id: 149,
          name: "سمنو",
        },
        {
          id: 150,
          name: "ابوقرين",
        },
        {
          id: 151,
          name: "القداحية",
        },
        {
          id: 152,
          name: "النوفلية",
        },
        {
          id: 153,
          name: "بن جواد",
        },
        {
          id: 154,
          name: "ابوهادي",
        },
        {
          id: 155,
          name: "راس لانوف",
        },
        {
          id: 156,
          name: "سرت",
        },
        {
          id: 157,
          name: "هراوة",
        },
        {
          id: 158,
          name: "طرابلس",
        },
        {
          id: 159,
          name: "الغابة",
        },
        {
          id: 160,
          name: "الغريبات",
        },
        {
          id: 161,
          name: "الغريفة",
        },
        {
          id: 162,
          name: "اوباري",
        },
        {
          id: 163,
          name: "جرمة",
        },
        {
          id: 164,
          name: "ادري",
        },
        {
          id: 165,
          name: "محروقة",
        },
        {
          id: 166,
          name: "براك",
        },
        {
          id: 167,
          name: "برقن",
        },
        {
          id: 168,
          name: "قطة",
        },
        {
          id: 169,
          name: "قردة",
        },
        {
          id: 170,
          name: "تمزاوة",
        },
        {
          id: 171,
          name: "تمسان",
        },
        {
          id: 172,
          name: "ونزريك",
        },
      ],
      municipalities: [],
         modal: false,
          matching_modal: false,
          is_matching:true,
          message: '', current_user: {
            nid: 219870345413,
            rid: 2695587,
            phone: 910000006,
           
            name: 'ايمان محمد محمد محمد',
            children_number: 5,
            type: 1,
          },  users:
            [
              {
                nid: 119851746513,
                rid: 2695587,
                phone: 910000000,
                type: 1,
                name: 'أحمد علي محمد محمد',
                children_number: '1985-03-15',
               
                passport_no: '543712',
                gender: 'ذكر',
                first_dose_date: '2021-06-02',
                second_dose_date: '2021-07-02',
                first_dose_type: 'AstraZeneca',
                second_dose_type: 'AstraZeneca',
              },
              {
                nid: 219870345413,
                rid: 2695587,
                phone: 910000001,
              
                name: 'فاطمة علي علي علي',
                children_number: '1987-05-02',
                type: 1,
                passport_no: '543712',
                gender: 'انثي',
                first_dose_date: '2021-06-02',
                second_dose_date: null,
                first_dose_type: 'Sinopharm',
                second_dose_type: null,
              },
              {
                nid: 219990345413,
                rid: 2695587,
                phone: 910000006,
                
                name: 'ايمان محمد محمد محمد',
                children_number: 5,
                type: 2,
              }
            ]
          ,
    };
  },
  methods: {       login() {

          var user = this.users.find(item => {
            return item.nid == this.login_nid
          })


          if (user == null) {
            this.modal = true;
            this.message = ' رجاء تأكد من الرقم الوطني الذي ادخلته';


          } else if (this.login_phone != user.phone) {
            this.modal = true;
            this.message = ' هذا الرقم الوطني الذي ادخلته غير مرتبط برقم الهاتف المدخل';

          } else {
            this.current_user = user;
            this.step = 2;
          }




        },
    send() {
      console.log(this.info);
      this.loading = true;

      if (this.info.residence == "other") {
        this.info.residence = this.info.otherresidence;
      }

      this.info.registeredBy = "webapp";
      this.info.municipalId = this.selectedmunicipality.id;

      axios.post("mobile/voters", this.info).then(
        (response) => {
          console.log(response);
          if (response.status == 200) {
            this.success = true;
            this.loading = false;
          } else {
            this.servererrors = response.data.message;
            this.loading = false;
          }
        },
        (error) => {
          this.servererrors = error.response.data.message;
          this.loading = false;
        }
      );
    },
  },
  mounted() {
    axios.get("mobile/municipalities/").then(
      (response) => {
        console.log(response);
        if (response.status == 200) {
          this.municipalities = response.data.data;
        } else {
          this.servererrors = response.data.message;
        }
      },
      (error) => {
        this.servererrors = error.response.data.message;
      }
    );
  },
};
</script>
<style scoped>
input[type="number"] {
  -moz-appearance: textfield;
  direction: ltr;
}

input[type="email"] {
  direction: ltr;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.animate-spin {
  animation: spin 1s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
</style>